var render = function render(){var _vm=this,_c=_vm._self._c;return _c('StatCard',{attrs:{"title":"Avg. Order Value","value":_vm.formattedValue,"icon":"receipt_long","icon-class":"aov-icon","trend":_vm.statsComparison.trend,"percentage":_vm.statsComparison.percentage,"comparison-period":_vm.comparisonPeriod}})
}
var staticRenderFns = []

export { render, staticRenderFns }